$(document).ready(function () {
    // --- Existing Code ---
    waitUntilElementExistAndStartFunction(100, disabledCheckoutOnStart, "#checkout-btn", 100);
    checkIfVisible("#multiplePickupWarning", 100, moveElement);
    $(document).on("click", '.terms-conditions input[type="checkbox"]', function (e) {
        if ($("#multiplePickupWarning").length > 0) {
            setTimeout(function () {
                $("#checkout-btn").attr("disabled", "disabled").css("pointer-events", "none").css("cursor", "default");
            }, 100);
        } else {
            if ($(this).is(":checked")) {
                $("#checkout-btn").removeAttr("disabled").css("pointer-events", "auto").css("cursor", "pointer");
            } else {
                $("#checkout-btn").attr("disabled", "disabled").css("pointer-events", "none").css("cursor", "default");
            }
        }
    });

    // --- Trigger Spacing Adjustment based on #tomit_inventory_list ---
    // Wait specifically for the #tomit_inventory_list element to be visible
    checkIfVisible("#tomit_inventory_list", 100, function() {
        // Once the list is visible, trigger the spacing adjustment
        adjustInventorySpacing();
    });
});

// --- Existing Functions (Unchanged) ---
const checkIfVisible = (element, interval, callback) => {
    var intervalId = setInterval(function () {
        // Check if element exists and is visible
        if ($(element).length > 0 && $(element).is(":visible")) {
            clearInterval(intervalId);
            callback();
        }
    }, interval);
};

const moveElement = () => {
    var elementContent = $("#multiplePickupWarning").parent().html();
    $("#multiplePickupWarning").parent().remove();
    $(".free-shipping").before(`<div id="multiplePickupWarning" style="color: red; font-weight: bold;">
        <p style="text-decoration: underline; margin-bottom: 10px;">WARNING</p>
        <p style="margin-bottom: 10px; line-height: 19px;">The Checkout process does not allow for Products to be shipped from multiple locations</p>
        <p style="margin-bottom: 10px; line-height: 19px;">Please adjust your order to ship from a single location.</p>
        <p style="margin-bottom: 10px; line-height: 19px;">If you would like to order Products from multiple locations, please complete separate orders or alternatively Live Chat or Call us at (866) 906-1159.</p>
        </div>`);
};

const disabledCheckoutOnStart = () => {
    $("#checkout-btn").attr("disabled", "disabled").css("pointer-events", "none").css("cursor", "default");
};

function waitUntilElementExistAndStartFunction(checkTimer, functionInfo, htmlElement, maxRepeat) {
    var counter = 0;
    var checkExist = setInterval(function () {
        if ($(htmlElement).length && !$(htmlElement).hasClass("wsaio_hideCheckout")) {
            clearInterval(checkExist);
            functionInfo();
        } else {
            counter++;
            if (counter === maxRepeat) {
                clearInterval(checkExist);
            }
        }
    }, checkTimer);
}

// --- Updated Spacing Function: Waits for #tomit_inventory_list ---
/**
 * Waits for the #tomit_inventory_list element to be present and visible,
 * then adjusts the spacing for all related inventory elements.
 */
function adjustInventorySpacing() {
    // Refine the selector to be more specific to the inventory section structure
    const selector = '.cart-left div[style*="margin-bottom: 1rem"]'; // Selector for product blocks
    const listSelector = '#tomit_inventory_list'; // Selector for the inventory list

    // Use an interval to wait for the product blocks and lists to be added and visible
    const waitForElements = setInterval(() => {
        // Check if the primary list element exists and is visible
        if ($(listSelector).length > 0 && $(listSelector).is(":visible")) {
            // Now find the container blocks that have these lists
            const $inventoryContainer = $(selector).has(listSelector);

            // Check if we found the product blocks containing the lists
            if ($inventoryContainer.length > 0) {
                 // Check if the first block is visible
                 if ($inventoryContainer.first().is(":visible")) {
                    clearInterval(waitForElements); // Stop checking

                    // --- Perform the actual spacing adjustments ---
                    $inventoryContainer.each(function (index) {
                        const $productBlock = $(this);
                        const $inventoryList = $productBlock.find(listSelector); // Find the specific list within this block

                        // Ensure the list exists within this block before modifying
                        if ($inventoryList.length > 0 && $inventoryList.is(":visible")) {

                            // 1. Increase space below Part # (Product Name)
                            // Target the <p> tag directly before the div containing the list
                            $productBlock.children('p').first().css('margin-bottom', '1.3rem');
                            $productBlock.children('p').first().css('margin-top', '1.3rem');

                            // 2. Reduce spacing between cities
                            $inventoryList.find('li').css({
                                'margin-bottom': '0.3rem'
                            });

                            // 3. Increase space after the last city of this product
                            // Ensure the last li within this specific list has larger margin
                            $inventoryList.find('li').last().css('margin-bottom', '1.5rem');
                        }
                    });

                   $(".cart-order-note h3").css('margin-top', '1.5rem');
                    // --- End of adjustments ---
                 }
            }
            // If containers not found/visible yet but list is, interval runs again
        }
        // If primary list not found/visible yet, interval runs again
    }, 100); // Check every 100ms

    // Optional: Clear the interval after a timeout to prevent potential infinite loops
    // setTimeout(() => clearInterval(waitForElements), 15000); // Stop after 15 seconds, for example
}